export function convertJavaRegexToJS (javaRegex: string | undefined) {
  if (!javaRegex) {
    return /.*/
  }
  // Remove extra backslashes used in Java string literals
  return new RegExp(javaRegex.replace(/\\\\/g, '\\'))
}
